import { useState } from "react";
import { subscriptionService, taskService } from "@miplatform/api";
import {
  ASSIGNMENT_TEMPLATE_TYPES,
  HTTP_STATUSES,
} from "@miplatform/constants";
import { useComponentState, useRouter } from "@miplatform/hooks";

export const useManageInspectionTemplateViewModel = () => {
  const [isAddModalVisible, setIsAddModalVisible] = useState(false);
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
  const [selectedInspectionTemplate, setSelectedInspectionTemplate] = useState(
    {}
  );
  const [inspectionTemplates, setInspectionTemplates] = useState([]);
  const [trades, setTrades] = useState([]);

  const stateManager = useComponentState();

  const { navigate } = useRouter();

  const loadInspectionTemplates = () => {
    stateManager.run(async () => {
      const response = await taskService.inspectionTemplates.getAll({
        sort: "name asc",
      });

      if (response.status === HTTP_STATUSES.OK) {
        setInspectionTemplates(
          response.data.map((orderType, index) => ({ ...orderType, index }))
        );
      }
    });
  };

  const toggleAddModal = () => {
    setIsAddModalVisible((prev) => !prev);
  };

  const handleAddInspectionTemplate = (data) => {
    stateManager.run(async () => {
      const { name } = data;
      const { status, data: { id } = {} } =
        await taskService.inspectionTemplates.create({
          data: { ...data, type: ASSIGNMENT_TEMPLATE_TYPES.INSTALL },
          toastMessageConfig: {
            success: {
              text: `${name} was created.`,
            },
          },
        });

      if (status === HTTP_STATUSES.OK) {
        toggleAddModal();
        navigate(`/settings/order-management/inspection-types/${id}/details`);
      }
    });
  };

  const closeDeleteModal = () => {
    setIsDeleteModalVisible(false);
  };

  const openDeleteModal = (orderType) => () => {
    setIsDeleteModalVisible(true);
    setSelectedInspectionTemplate(orderType);
  };

  const onDelete = () => {
    stateManager.run(async () => {
      const { id, name, modifiedOn } = selectedInspectionTemplate;
      const { status } = await taskService.inspectionTemplates.delete({
        id,
        modifiedOn,
        toastMessageConfig: {
          success: {
            text: `${name} was deleted.`,
          },
        },
      });

      if (status === HTTP_STATUSES.OK) {
        loadInspectionTemplates();
        closeDeleteModal();
      }
    });
  };
  const getTrades = () => {
    stateManager.run(async () => {
      const response = await subscriptionService.trades.getAll();
      if (response.status === HTTP_STATUSES.OK) {
        const updatedTrades = response.data.map(({ name, id }) => ({
          label: name,
          value: id,
        }));

        setTrades(updatedTrades);
      }
    });
  };

  return {
    inspectionTemplates,
    trades,
    isAddModalVisible,
    isLoading: stateManager.isBusy(),
    isDeleteModalVisible,
    selectedInspectionTemplate,
    loadInspectionTemplates,
    handleAddInspectionTemplate,
    toggleAddModal,
    openDeleteModal,
    onDelete,
    closeDeleteModal,
    getTrades,
  };
};
